// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".webassets-page{margin-left:20px;margin-right:20px}.webassets-page .table-header{padding:10px}.webassets-page .table-header .title{font-size:24px;font-weight:600}.webassets-page .add-new-button{display:inline;float:right;margin-top:5px}.webassets-page .actions-col{width:inherit}.webassets-page .actions-col i{cursor:pointer;margin-right:10px}", ""]);
// Exports
module.exports = exports;
